import React, { ReactElement } from 'react';

import { AsaphButton } from '@/components/shared/Button';
import { classNames } from '@/helpers/classNames';

import styles from './SingleActionLayout.module.scss';

export interface SingleActionLayoutProps {
	topContent?: ReactElement;
	actionLabel: string;
	actionColor?: 'blue' | 'grey';
	className?: string;
	actionClassName?: string;
	actionTopContent?: ReactElement;
	actionDivider?: boolean;
	actionHidden?: boolean;
	leadingContent?: ReactElement;
	trailingContent?: ReactElement;
	actionDisabled?: boolean;
	noPadding?: boolean;
	contentClassName?: string;
	onActionClick: () => void;
	onScroll?: (scrollTop: number, offsetHeight: number) => void;
}

export const SingleActionLayout: React.FC<SingleActionLayoutProps> = ({
	topContent,
	children,
	actionLabel,
	actionColor = 'blue',
	className,
	actionClassName,
	actionTopContent,
	actionHidden,
	leadingContent,
	trailingContent,
	actionDisabled,
	noPadding,
	actionDivider,
	contentClassName,
	onActionClick,
	onScroll,
}) => {
	const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
		if (onScroll) {
			onScroll(
				event.currentTarget.scrollTop,
				event.currentTarget.offsetHeight,
			);
		}
	};

	return (
		<div className={classNames([styles['layout'], className])}>
			{!!topContent && (
				<>
					<div
						className={classNames([
							styles['list'],
							noPadding && styles['no-padding'],
						])}
					>
						{topContent}
					</div>
				</>
			)}
			<div
				className={classNames([styles['content'], contentClassName])}
				onScroll={handleScroll}
			>
				<div
					className={classNames([
						styles['list'],
						noPadding && styles['no-padding'],
					])}
				>
					{children}
				</div>
			</div>
			{!actionHidden && (
				<div
					className={classNames([
						styles['action-container'],
						actionDivider && styles['with-divider'],
						actionTopContent && styles['less-top-padding'],
					])}
				>
					{!!actionTopContent && actionTopContent}
					<div className={styles['action-leading-trailing-group']}>
						{leadingContent && leadingContent}
						<AsaphButton
							color={actionColor}
							className={actionClassName}
							label={actionLabel}
							onClick={onActionClick}
							disabled={actionDisabled}
							fullWidth
						/>
						{trailingContent && trailingContent}
					</div>
				</div>
			)}
		</div>
	);
};
